// src/components/Navbar.js
import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Avatar from "./Avatar";
import "./Navbar.css";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const closeMenu = () => {
    const navbar = document.getElementById("navbarNav");
    if (navbar && navbar.classList.contains("show")) {
      navbar.classList.remove("show");
    }
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark navbar-autotech shadow-sm">
      <div className="container-fluid">
        <NavLink className="navbar-brand fs-4" to="/" onClick={closeMenu}>
          AUTOTECH
        </NavLink>

        {/* Toggler */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <NavLink className="nav-link" to="/todo" onClick={closeMenu}>
                Jobblista
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/jour" onClick={closeMenu}>
                Jour
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/vacation" onClick={closeMenu}>
                Semester
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/vacation-overview" onClick={closeMenu}>
                Semesteröversikt
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/bugreport" onClick={closeMenu}>
                Felrapport
              </NavLink>
            </li>

            {/* Admin dropdown */}
            {user?.role === "admin" && (
              <li className="nav-item dropdown">
                <span
                  className="nav-link dropdown-toggle"
                  id="adminDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  style={{ cursor: "pointer" }}
                >
                  Admin
                </span>
                <ul className="dropdown-menu dropdown-menu-dark" aria-labelledby="adminDropdown">
                  <li>
                    <NavLink className="dropdown-item" to="/admin" onClick={closeMenu}>
                      Användare
                    </NavLink>
                  </li>
                  <li>
                    <NavLink className="dropdown-item" to="/vacation-admin" onClick={closeMenu}>
                      Semesterhantering
                    </NavLink>
                  </li>
                  <li>
                    <NavLink className="dropdown-item" to="/settings" onClick={closeMenu}>
                      Inställningar
                    </NavLink>
                  </li>
                  <li>
                    <NavLink className="dropdown-item" to="/completed-admin" onClick={closeMenu}>
                      Slutförda jobb
                    </NavLink>
                  </li>
                  <li>
                    <NavLink className="dropdown-item" to="/vehicles" onClick={closeMenu}>
                      Fordon
                    </NavLink>
                  </li>
                  <li>
                    <NavLink className="dropdown-item" to="/warnings" onClick={closeMenu}>
                      Varningar
                    </NavLink>
                  </li>
                </ul>
              </li>
              
            )}
            {user?.role === "admin" && (
              <li className="nav-item dropdown">
                <span
                  className="nav-link dropdown-toggle"
                  id="adminDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  style={{ cursor: "pointer" }}
                >
                  Utgångs
                </span>
                <ul className="dropdown-menu dropdown-menu-dark" aria-labelledby="adminDropdown">
                  <li>
                    <NavLink className="dropdown-item" to="/ssg" onClick={closeMenu}>
                      Anställda
                    </NavLink>
                  </li>
                  <li>
                    <NavLink className="dropdown-item" to="/vehicles" onClick={closeMenu}>
                      Fordon
                    </NavLink>
                  </li>
                  <li>
                    <NavLink className="dropdown-item" to="/warnings" onClick={closeMenu}>
                      Varningar
                    </NavLink>
                  </li>
                </ul>
              </li>
            )}

            {/* Dev dropdown */}
            {user?.isDev && (
              <li className="nav-item dropdown">
                <span
                  className="nav-link dropdown-toggle"
                  id="devDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  style={{ cursor: "pointer" }}
                >
                  Dev
                </span>
                <ul className="dropdown-menu dropdown-menu-dark" aria-labelledby="devDropdown">
                  <li>
                    <NavLink className="dropdown-item" to="/bug-list" onClick={closeMenu}>
                      Bugg Rapporter
                    </NavLink>
                  </li>
                </ul>
              </li>
            )}
          </ul>

          {user && (
            <div
              className="d-flex align-items-center user-link cursor-pointer"
              role="button"
              onClick={() => {
                closeMenu();
                navigate("/profile");
              }}
            >
              <Avatar
                initials={user?.avatar?.initials}
                color={user?.avatar?.color}
                size={32}
              />
              <span className="ms-2 text-white fw-semibold">
                {user.firstName} {user.lastName}
              </span>
              <button
                className="btn btn-danger btn-sm rounded-pill px-3 ms-3"
                onClick={(e) => {
                  e.stopPropagation();
                  logout();
                  closeMenu();
                }}
              >
                Logga ut
              </button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
}
